export default __webpack_public_path__ + "static/media/0022.0002cd46.jpg";